<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT IMAGE ORDER
      </h6>
      <EditTagsDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <modal
      :show.sync="tableModal"
      header-classes="bg-primary p-3 "
      class="modal-lg"
      size="lg"
    >
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        Orders
      </h6>
      <VendorTable :selectedName="selectedName" />
      <!-- <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="tableModal = false"
          >CLOSE</base-button
        >
      </template> -->
    </modal>
    <AddTagsSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />
    <div class="flex  justify-between  items-center">
      <div>
        <h2 class="text-2xl font-semibold">
          Shipway Integration
        </h2>
        <!-- 
        <small class=" text-muted "
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        </small> -->
      </div>
      <div class="flex">
        <base-button outline type="success" class="flex">
          <!-- <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> -->
          Export
        </base-button>
        <base-button outline type="success" class="flex" @click="addBanner">
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add Shipment
        </base-button>
      </div>
    </div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-color"
      :data="TagsData"
    >
      <el-table-column prop="checkbox" min-width="80px">
        <template slot="header">
          <label class="custom-checkbox" id="allcheck">
            <input type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </template>
        <template>
          <label class="custom-checkbox" id="allcheck">
            <input type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </template>
      </el-table-column>
      <el-table-column
        label="Order ID"
        prop="orderID"
        min-width="120px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.orderID }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Delivery Partner"
        min-width="150px"
        prop="deliveryPartner"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.deliveryPartner }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="AWB Number"
        min-width="150px"
        prop="awbNo"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.awbNo }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Current Status"
        min-width="160px"
        prop="currentStatus"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.currentStatus }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Customer Details"
        min-width="160px"
        prop="custdetails"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.custdetails }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Destination"
        min-width="120px"
        prop="destination"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.destination }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Pickup Date"
        min-width="140px"
        prop="pickupDate"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.pickupDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Expected Delivery"
        min-width="150px"
        prop="expectedDelivery"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{
            row.expectedDelivery
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="En-Route Days"
        min-width="90px"
        prop="enrouteDays"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.enrouteDays }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Date Added"
        min-width="150px"
        prop="dateAdded"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.dateAdded }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Action" min-width="80px">
        <div class="flex items-center">
          <div class="flex items-center mr-4 cursor-pointer">
            <feather-icon
              @click="addBanner"
              block
              icon="EditIcon"
              svgClasses="w-5"
              data-toggle="tooltip"
              data-placement="top"
              title="Edit"
            ></feather-icon>
          </div>
        </div>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="10"
        :total="50"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import TagsData from "./components/TagsData";

import TableTagsData from "./components/TableTagsData";
import EditTagsDetail from "./components/EditTagsDetail";
import VendorTable from "./components/VendorTable";
import AddTagsSidebar from "./components/AddTagsSidebar";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTagsDetail,
    AddTagsSidebar,
    VendorTable
  },
  data() {
    return {
      TagsData,
      TableTagsData,
      currentPage: 1,
      editModal: false,
      tableModal: false,
      openAddBannerSidebar: false,
      selectedName: ""
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
